import { TableData, TableHeader } from '@fairfashion/design-system'

export const risksHeaders: TableHeader[] = [
  { key: 'type', label: 'Tipo de risco', width: '30%', minWidth: '100px' },
  { key: 'description', label: 'Descrição', minWidth: '200px' },
]

export const risksData: TableData[] = [
  {
    type: 'Embargos Ambientais',
    description: 'Análise de satélite, denúncias e processos ambientais',
  },
  {
    type: 'Trabalho análogo à escravidão',
    description: 'Listas de denúncia de trabalho escravo',
  },
  {
    type: 'Situação Cadastral',
    description: 'Verificação da conformidade do CNPJ',
  },
]
